import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useCallback, useEffect, useState } from 'react';
import { getSelectedAccountInfo } from '@ibk/shared-auth';
import { selectAppDomain, useAppSelector } from '@ibk/shared-config';
import { FeatureFlagUseCase, useFeatureFlag } from '@ibk/shared-feature-flags';
import { useTranslation } from '@ibk/shared-translation';
import { AppDomain } from '@ibk/shared-types';
import { Loading, Modal } from '@ibk/shared-ui';
import { isValidCpf } from '@ibk/shared-utils';
import { useCreatePluggyTokenMutation } from '../../../../services/openFinanceApi';
import { ConsentPartner } from '../../../../services/types';
import BelvoModal from './BelvoModal';
import { PluggyWidgetConnectorType, WidgetPluggy } from './WidgetPluggy';
export const ConsentModal = ({ isModalOpen, setIsModalOpen, onSuccess, }) => {
    const [pluggyToken, setPluggyToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [pluggyKey, setPluggyKey] = useState(0);
    const [createPluggyToken, { isLoading: isCreatingPluggyToken }] = useCreatePluggyTokenMutation();
    const [pluggyConnectorType, setPluggyConnectorType] = useState(PluggyWidgetConnectorType.PERSONAL_BANK);
    const { t } = useTranslation();
    const [belvoToken, setBelvoToken] = useState(null);
    const [consentPartner, setConsentPartner] = useState(ConsentPartner.PLUGGY);
    const appDomain = useAppSelector(selectAppDomain);
    const { isFeatureFlagWhiteListed, getFeatureFlags } = useFeatureFlag();
    const getIsBelvoWhiteListed = useCallback(async () => {
        const featureFlagsData = await getFeatureFlags();
        const usedFeatureFlag = appDomain === AppDomain.EMPRESA
            ? FeatureFlagUseCase.BELVO_WIDGET_ACCESS_CLIENT
            : FeatureFlagUseCase.BELVO_WIDGET_ACCESS_ACCOUNTANT;
        const isBelvoWhiteListed = isFeatureFlagWhiteListed(usedFeatureFlag, undefined, featureFlagsData);
        if (isBelvoWhiteListed) {
            setConsentPartner(ConsentPartner.BELVO);
        }
    }, [getFeatureFlags, isFeatureFlagWhiteListed, appDomain]);
    const handleCloseConsentModal = () => {
        setIsModalOpen(false);
        setBelvoToken(null);
    };
    const getConsentPartner = useCallback(async () => {
        const accountInfo = getSelectedAccountInfo();
        const { result } = await createPluggyToken({ partyId: accountInfo?.id || '', avoidDuplicates: true }).unwrap();
        const connectorType = isValidCpf(accountInfo?.documentNumber || '')
            ? PluggyWidgetConnectorType.PERSONAL_BANK
            : PluggyWidgetConnectorType.BUSINESS_BANK;
        setPluggyConnectorType(connectorType);
        if (!!result.token && !!connectorType) {
            setPluggyToken(result.token);
            return;
        }
    }, [createPluggyToken]);
    useEffect(() => {
        if (!pluggyToken && consentPartner === ConsentPartner.PLUGGY) {
            getConsentPartner();
        }
    }, [getConsentPartner, pluggyToken, consentPartner]);
    useEffect(() => {
        if (isModalOpen) {
            getIsBelvoWhiteListed();
            setPluggyKey(prev => prev + 1);
        }
    }, [isModalOpen, getIsBelvoWhiteListed]);
    useEffect(() => {
        setIsLoading(isCreatingPluggyToken);
    }, [isCreatingPluggyToken]);
    if (isLoading) {
        return (_jsx(Modal, { isOpen: isModalOpen, onClose: handleCloseConsentModal, showCloseButton: false, children: _jsx(Loading, {}) }));
    }
    if (pluggyToken && isModalOpen && consentPartner === ConsentPartner.PLUGGY) {
        return (_jsx(WidgetPluggy, { connectToken: pluggyToken, onClose: handleCloseConsentModal, onSuccess: onSuccess, connectorType: pluggyConnectorType }, pluggyKey));
    }
    else if (consentPartner === ConsentPartner.BELVO) {
        return (_jsx(BelvoModal, { belvoToken: belvoToken, handleCloseConsentModal: handleCloseConsentModal, setBelvoToken: setBelvoToken, isModalOpen: isModalOpen, translate: t }));
    }
    return _jsx(_Fragment, {});
};
